module.exports = __webpack_public_path__ + "img/lock-fill.951a1ece.svg";